(()=>{'use strict';
  // Reuse the page's existing carousel controls; keep its pause and motion rules.
  document.addEventListener('click',event=>{
    const photo=event.target.closest?.('.us-story-photo');
    if(photo)photo.closest('#customer-stories')?.querySelector('[aria-label="Next customer story"]')?.click();
  });
  const start=()=>{
    const sizeGuide=document.querySelector('#cb-studio-details #size-guide');
    const imageMap=document.querySelector('#bf-studio-image-urls');
    if(sizeGuide&&imageMap){
      let urls={};try{urls=JSON.parse(imageMap.textContent);}catch{}
      const loadSizeModels=()=>{
        for(const img of sizeGuide.querySelectorAll('img[data-cb-image^="size-model-"]')){
          const url=urls[img.dataset.cbImage];
          if(!img.getAttribute('src')&&typeof url==='string'&&url){img.decoding='async';img.src=url;}
        }
      };
      if('IntersectionObserver'in window){
        const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){loadSizeModels();observer.disconnect();}},{rootMargin:'200px'});
        observer.observe(sizeGuide);
      }else loadSizeModels();
    }
    for(const gallery of document.querySelectorAll('.bf-studio-shell .cb-customer-gallery')){
      const pruneCaption=()=>{for(const p of gallery.querySelectorAll(':scope > p'))if(p.textContent.trim()==='Real customer moments · personalised gifts in their hands')p.remove();};
      pruneCaption();
      // The native controller may append this former caption during its later setup.
      new MutationObserver(pruneCaption).observe(gallery,{childList:true});
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
